import { render, staticRenderFns } from "./DesktopEventIconSimple.vue?vue&type=template&id=5723e4be"
import script from "./DesktopEventIconSimple.vue?vue&type=script&lang=js"
export * from "./DesktopEventIconSimple.vue?vue&type=script&lang=js"
import style0 from "./DesktopEventIconSimple.vue?vue&type=style&index=0&id=5723e4be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports